import type { AdminApiPlaybookPublishedVersion } from "@repo/app-types/entities/playbook";
import type { FC } from "react";
import {
  useGetPlaybookVersionsQuery,
  useRollbackPlaybookMutation,
} from "../../api/entities/playbook.js";
import { VersionHistoryPopover } from "./versionHistoryPopover.js";

export interface PlaybookVersionHistoryButtonProps {
  playbookId: string;
  isDisabled?: boolean;
  onRollbackComplete?: () => void;
}

export const PlaybookVersionHistoryButton: FC<
  PlaybookVersionHistoryButtonProps
> = ({ playbookId, isDisabled, onRollbackComplete }) => {
  const { data: versions, isLoading } = useGetPlaybookVersionsQuery(playbookId);

  const [rollback, { isLoading: isRollingBack }] =
    useRollbackPlaybookMutation();

  const handleRollback = async (version: AdminApiPlaybookPublishedVersion) => {
    await rollback({
      playbookId,
      playbookRevisionId: version.id,
    }).unwrap();
    onRollbackComplete?.();
  };

  return (
    <VersionHistoryPopover
      versions={versions}
      isLoading={isLoading}
      isRollingBack={isRollingBack}
      isDisabled={isDisabled}
      getLabel={(version) => version.name}
      onRollback={handleRollback}
      restoreTargetDescription="your current live playbook"
    />
  );
};
